import React, { useEffect, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useConfiguration } from 'components/hooks';
import { HeadlinePage } from 'components/common';
import { useTranslation } from 'react-i18next';
import { configurationPolicies } from 'helpers';
import { useStyle } from './styles';
import { Input } from 'components/layout';
import {
  Paper,
  Grid,
  CircularProgress,
  Backdrop,
  Button,
  Typography
} from '@mui/material';
import { ROUTES } from 'consts';
import { Visibility } from '@mui/icons-material';

export default function ConfigurationFormDumb({ defaultValues, handleOnSubmit, isEdit }) {
  const { isLoaded} = useConfiguration();
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, reset, control } = methods;

  const fields = [
    { policy: configurationPolicies.ansibleRunerPath },
    { policy: configurationPolicies.mailHost },
    { policy: configurationPolicies.mailPort },
    { policy: configurationPolicies.mailUser },
    { policy: configurationPolicies.mailPass },
    { policy: configurationPolicies.mailFrom },
    { policy: configurationPolicies.mailSecure },
    { policy: configurationPolicies.mailRejectUnauthorized },
    { policy: configurationPolicies.threads},
    { policy: configurationPolicies.inventory_path},
    { policy: configurationPolicies.macros_playbook_path},
    { policy: configurationPolicies.macros_playbook},
    { policy: configurationPolicies.macros_config_path},
    { policy: configurationPolicies.ansibleConfig , hide:true},
  ];

  useEffect(() => {
    if (isEdit) reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.put}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={'configurationEdit.headline'} goBack={ROUTES.INVENTORY_LIST}/>
      <FormProvider { ...methods }>
        <Paper className={classes.paperTemplate}>
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Typography variant="h6" sx={{ padding: '8px 0px' }}>
              {t('configuration.form.title')}
            </Typography>

            <Grid container spacing={2}>
              {fields.map((field) => (
                <Grid item xs={12} sm={12} md={4} lg={3} key={field.policy.id} sx={{ visibility: field.hide?'hidden':null }}>
                  <Input
                    {...field.policy}
                    control={control}
                    options={field.options}
                    sx={{ width: '100%' }}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} type='submit'>
                  {t('configurationEdit.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
          </form>
        </Paper>
      </FormProvider>
    </>
  );
}
